import CreateBrokerForm from 'components/features/create-broker-form';
import HomeLayout from 'layouts/home-layout';

function CreateBroker() {
  return (
    <HomeLayout title="Create Broker">
      <CreateBrokerForm />
    </HomeLayout>
  );
}

export default CreateBroker;
